const PUBLIC_EXACT_PATHS = ['/completed-documents'];
const PUBLIC_TOKEN_PATH_PREFIXES = [
  '/sign/',
  '/completed-documents/',
  '/referrals/access/',
  '/referrals/fax/'
];
// Requires a token segment — `/referrals/access/` alone must not re-enable PostHog.
const REFERRAL_ACCESS_TOKEN_PATH = /^\/referrals\/(access|fax)\/[^/]+(\/|$)/;

// Detected at module-evaluation time, BEFORE React Router mounts. Public token
// routes must opt out of any telemetry / support tooling that would capture the
// bearer token in the URL or any rendered PHI (signatures, names).
export function isPublicESignRoute() {
  return (
    typeof window !== 'undefined' &&
    (PUBLIC_EXACT_PATHS.includes(window.location.pathname) ||
      PUBLIC_TOKEN_PATH_PREFIXES.some((prefix) =>
        window.location.pathname.startsWith(prefix)
      ))
  );
}

export function isPublicSignerRoute() {
  return isPublicESignRoute();
}

// Referral-access magic links require a second factor (emailed passcode) on
// top of the URL token, so — unlike eSign — this route is allowed to load
// PostHog. Sentry / session-replay / third-party JS stay off via
// isPublicESignRoute() above; this only carves out the PostHog gate.
export function isPublicReferralAccessRoute() {
  return (
    typeof window !== 'undefined' &&
    REFERRAL_ACCESS_TOKEN_PATH.test(window.location.pathname)
  );
}
